/**
 * 应用配置管理
 * 从环境变量中读取配置,提供统一的配置访问接口
 */

// API 基础 URL
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8087'

// 上传文件基础 URL（生产环境为空，因为图片路径已包含 /uploads）
export const UPLOAD_BASE_URL = process.env.VUE_APP_UPLOAD_BASE_URL !== undefined 
  ? process.env.VUE_APP_UPLOAD_BASE_URL 
  : 'http://localhost:8087'

// 应用标题
export const APP_TITLE = process.env.VUE_APP_TITLE || '彩辉印刷 CMS'

// 判断是否为生产环境
export const isProduction = process.env.NODE_ENV === 'production'

// 判断是否为开发环境
export const isDevelopment = process.env.NODE_ENV === 'development'

/**
 * 获取完整的图片 URL
 * @param {string} url - 图片相对路径或完整 URL
 * @returns {string} 完整的图片 URL
 */
export function getFullImageUrl(url) {
  if (!url) return ''
  
  // 如果已经是完整 URL(http:// 或 https:// 开头),直接返回
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  
  // 否则添加上传服务器地址前缀
  return `${UPLOAD_BASE_URL}${url}`
}
